import React from 'react'

const Location = () => {
  return (
    <section id='location' className='background-black'>
      <div className="container text-center color-secondary">
        <div className="custom-shape-divider-top-1677776805">
          <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
              <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="shape-fill"></path>
          </svg>
        </div>
        <div>
          <h2 className='mb-5'>Lokasi Black Canyon Transport</h2>
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d997.3270017110996!2d119.89121978812636!3d-0.9163981999579999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2d8bee02c25978a5%3A0x3012d9a0771d13b5!2sJalur%20Dua%20Jl.%20Prof.%20Moh.%20Yamin%20No.38B%2C%20Birobuli%20Utara%2C%20Kec.%20Palu%20Sel.%2C%20Kota%20Palu%2C%20Sulawesi%20Tengah%2094111!5e0!3m2!1sid!2sid!4v1677777261789!5m2!1sid!2sid" 
            className='maps'
            allowFullScreen={true} 
            loading="lazy" 
            referrerPolicy="no-referrer-when-downgrade" 
            title='maps'
          ></iframe>
          <h4 className='address'>Alamat : Jl. Prof. Moh. Yamin No.38b, Birobuli Utara</h4>
          <h4 className='address'>Kota Palu, Sulawesi Tengah</h4>
        </div>
        <div className="custom-shape-divider-bottom-1677776968">
          <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="shape-fill"></path>
          </svg>
        </div>
      </div>
    </section>
  )
}

export default Location